import { AbstractControl } from '@angular/forms';

export function BudgetMaxStodnivaHigher(control: AbstractControl) {
  if (control.value) {
    const parsedValue = JSON.parse(control.value);
    const noMaxStodnivaHigher = !parsedValue.projektparter.some(
      (p) =>
        p.bidragPerAr.some((bidrag) => bidrag.summa > 0) &&
        p.maxStodniva?.varde > 100,
    );
    if (noMaxStodnivaHigher) {
      return;
    }
  }

  return { MaxStodnivaHigher: true };
}
